import { useCallback, useRef, useState } from 'react';
const UNKNOWN_INDEX = 'unknown';
function getLayersFromLayerMap(layerMap) {
  const ls = Object.entries(layerMap).reduce((prev, [key, layerOpts]) => {
    const {
      layer,
      index
    } = layerOpts;
    prev.push([index, layer]);
    return prev;
  }, []).sort((layerA, layerB) => {
    const [indexA, lA] = layerA;
    const [indexB, lB] = layerB;
    if (typeof indexA === 'number' && typeof indexB === 'number') {
      if (indexA === indexB) {
        return lA.id > lB.id ? 1 : -1;
      }
      return indexA > indexB ? 1 : -1;
    }
    if (typeof indexA === 'number') {
      return 1;
    }
    if (typeof indexB === 'number') {
      return -1;
    }
    return 0;
  }).map(layerOpts => layerOpts[1]);
  return ls;
}
export default function useLayerManager() {
  const layerMap = useRef({});
  const [layers, setLayers] = useState([]);
  const addLayers = useCallback((layers, index) => {
    if (Array.isArray(layers)) {
      layers.forEach(layer => {
        const {
          id
        } = layer;
        layerMap.current[id] = {
          layer,
          index: index != null ? index : UNKNOWN_INDEX
        };
      });
    } else {
      const {
        id
      } = layers;
      layerMap.current[id] = {
        layer: layers,
        index: index != null ? index : UNKNOWN_INDEX
      };
    }
    const ls = getLayersFromLayerMap(layerMap.current);
    setLayers([...ls]);
  }, []);
  const removeLayers = useCallback(layers => {
    if (Array.isArray(layers)) {
      layers.forEach(layer => {
        delete layerMap.current[layer.id];
      });
    } else {
      delete layerMap.current[layers.id];
    }
    const ls = getLayersFromLayerMap(layerMap.current);
    setLayers([...ls]);
  }, []);
  return {
    layers,
    addLayers,
    removeLayers
  };
}